/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LicenseOption = {
    None: 'None',
    DeploymentServices: 'DeploymentServices',
    DosimetrySchoolTraining: 'DosimetrySchoolTraining',
    LocationManagement: 'LocationManagement'
} as const;
export type LicenseOption = typeof LicenseOption[keyof typeof LicenseOption];


export function LicenseOptionFromJSON(json: any): LicenseOption {
    return LicenseOptionFromJSONTyped(json, false);
}

export function LicenseOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseOption {
    return json as LicenseOption;
}

export function LicenseOptionToJSON(value?: LicenseOption | null): any {
    return value as any;
}

/**
 * Check if a given object implements the LicenseOption interface.
 */
 export function instanceOfLicenseOption(value: any): value is LicenseOption {
    return Object.values(LicenseOption).includes(value)
}

